/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ProviderDetailsIntegrationViewModel {
  /**
   * Provider Id (not used for Add)
   */
  id?: string | null;
  /**
   * Dataset Id (not used for Add)
   */
  datasetId?: string;
  /**
   * Provider Code
   */
  providerCode?: string | null;
  /**
   * Provider Last Name, maximum length 50
   */
  lastName?: string | null;
  /**
   * Provider First Name, maximum length 50
   */
  middleName?: string | null;
  /**
   * Provider Middle Name, maximum length 50
   */
  firstName?: string | null;
  /**
   * Provider Title, maximum length 100
   */
  title?: string | null;
  /**
   * Provider Address Line 1, maximum length 100
   */
  address1?: string | null;
  /**
   * Provider Address Line 2, maximum length 100
   */
  address2?: string | null;
  /**
   * Provider City, max length 50
   */
  city?: string | null;
  /**
   * Provider state code, must be a valid US state code
   */
  stateCode?: string | null;
  /**
   * Provider Zipcode, max length 20
   */
  zip?: string | null;
  /**
   * Provider Phone Number, max length 30
   */
  phone?: string | null;
  /**
   * Provider Fax number, max length 30
   */
  fax?: string | null;
  /**
   * Provider email address, max length 100
   */
  email?: string | null;
  /**
   * Provider NPI, max length 20
   */
  npi?: string | null;
  /**
   * Provider tax id number, max length 20
   */
  taxId?: string | null;
  /**
   * Provider Taxonomy code. Max length 100
   */
  taxonomy?: string | null;
  /**
   * Provider Mailing address line 1, max length 100
   */
  mailingAddress1?: string | null;
  /**
   * Provider Mailing address line 2, max length 100
   */
  mailingAddress2?: string | null;
  /**
   * Provider Mailing address city, max length 100
   */
  mailingCity?: string | null;
  /**
   * Provider Mailing address state code, must be a valid US state code
   */
  mailingStateCode?: string | null;
  /**
   * Provider Mailing address zipcode, max length 20
   */
  mailingZip?: string | null;
  /**
   * Option to inactivate provider
   */
  inactive?: boolean | null;
  /**
   * Option to hold insurance billing for this provider
   */
  holdBilling?: boolean | null;
  /**
   * This option is true if the provider is an Attending Provider for the practice.
   */
  isBillable?: boolean | null;
  /**
   * Additional Provider Id
   */
  additionalId?: string | null;
  /**
   * Additional Provider Id Qualifier (valid values: G2, 0B, 1G, LU)
   */
  additionalIdQualifier?: string | null;
  /**
   * Provider SSN
   */
  ssn?: string | null;
  /**
   * Default modifier for provider
   */
  providerDefaultModifier1?: string | null;
  /**
   * Default modifier id (not used for add)
   */
  defaultModifier1Id?: string | null;
  /**
   * Default supervising provider code for provider
   */
  providerDefaultSupervisor?: string | null;
  /**
   * Default supervising provider id (not used for add)
   */
  defaultSupervisingProviderId?: string | null;
  /**
   * Default Value Code Id
   */
  defaultValueCode1Id?: string | null;
  /**
   * Default Value Code Id (not used for add)
   */
  defaultValueCode1?: string | null;
  /**
   * Default Value Code Amount
   */
  defaultValue1Amount?: number | null;
}
